
import {isDev} from '../../utils/Utils';
import {formatImageToSvg} from '../../../web/src/resources/styles/js/custom';

let singleton = {};

const localAssets = {
  imgBannerCta1:      require('./images/bg-banner-cta-1.jpg').default,
  imgBannerCta2:      require('./images/bg-banner-cta-2.jpg').default,
};

const localSvg = [
  {key: "icAdviser",          value: require('./icons/ic_adviser.svg').default},
  {key: "icAdviser2",         value: require('./icons/ic_adviser_2.svg').default},
  {key: "icCheck",            value: require('./icons/ic_check.svg').default},
  {key: "icComparative",      value: require('./icons/ic_comparative.svg').default},
  {key: "icError",            value: require('./icons/ic_error.svg').default},
  {key: "icPlaceholderModel", value: require('./icons/ic_placeholderModel.svg').default},
  {key: "imgLogoDucati",     value: require('./images/img_logo_ducati.svg').default},
  {key: "icSymbolDucati",    value: require('./icons/ic_symbolDucati.svg').default},
  {key: "icComparator",       value: require('./icons/ic_comparator.svg').default},
  {key: "icChatbubbles",      value: require('./icons/ic_chatbubbles.svg').default},
  {key: "icSearch",           value: require('./icons/ic_search.svg').default},
  {key: "icColorFilter",      value: require('./icons/ic_colorFilter.svg').default},
  {key: "icFlash",            value: require('./icons/ic_flash.svg').default},
  {key: "icEngine",           value: require('./icons/ic_engine.svg').default},
  {key: "icGearbox",          value: require('./icons/ic_gearbox.svg').default},
  {key: "icFuelMeter",          value: require('./icons/ic_fuelMeter.svg').default},
]

/** ********* **/
/** SINGLETON **/
/** ********* **/
const getAsset = (svg) => {
  if (!singleton || singleton === {} || !singleton[svg]) {
    if (isDev()) console.log("No singleton - getAssets()");
    getAssets()
  }

  return singleton[svg];
};

const  getAssets = async() => {
  await getIcons(localSvg)
};


const getIcons = async(assetsArray) => {
  return await Promise.all(
    assetsArray.map(async (item) => {
      return {[item.key]: await formatImageToSvg(`<img src=${item.value} class="svg"/>`)}
    })
  ).then( source => {
    source.map((item) => {
      singleton = {...singleton, ...item}
    })
  })
};


export { localAssets, getAsset, getAssets };
